import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-166">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-167">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-168" />
          <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="relative w-full max-w-2xl max-h-[80vh] bg-surface border border-white/10 overflow-hidden flex flex-col" data-id="element-169">
            <div className="flex items-center justify-between p-6 border-b border-white/10 shrink-0" data-id="element-170">
              <h2 className="text-xl font-display font-bold text-white" data-id="element-171">
                {title}
              </h2>
              <button onClick={onClose} className="text-gray-500 hover:text-white transition-colors p-1" aria-label="Cerrar" data-id="element-172">
                <X className="w-5 h-5" data-id="element-173" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto text-gray-300 text-sm leading-relaxed space-y-4" data-id="element-174">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}